import { mapGetters, mapActions } from 'vuex'
import types from '../../store/globaltypes'
import { isIOSApp, isMobileApp } from '../../helpers/platform'

export default {
  name: 'login',
  components: {},
  props: [],
  data () {
    return {
      showLogo: !isMobileApp(),
      passwordVisibility: false,
      regpasswordVisibility: false,
      regpasswor2dVisibility: false,
      email: '',
      password: '',
      valid: false,
      loggingIn: false,
      showResetAccount: false,
      currentAccountType: '',
      showRegisterPage: false,
      registeremail: '',
      registerpassword2: '',
      registerpassword: '',
      registerfirstname: '',
      registerlastname: ''
    }
  },
  computed: {
    ...mapGetters({
      user: types.user.getters.currentUser,
      info: types.main.getters.information
    }),
    rules () {
      return {
        required: value => !!value || this.$t('login.required_field'),
        equal: value => value === this.registerpassword || this.$t('login.passwords_dont_match'),
        email: value => /.+@.+/.test(value) || this.$t('login.email_is_not_valid')
      }
    },
    iOS () {
      return isIOSApp()
    }
  },
  mounted () {
    if (this.user) {
      this.fill()
      this.$router.push({ name: (this.$route.query.redirect || 'crops') })
    } else {
      // this.tryAutoSignIn()
    }
  },
  methods: {
    ...mapActions({
      signInWithFacebook: types.user.actions.signInWithFacebook,
      signInWithApple: types.user.actions.signInWithApple,
      signIn: types.user.actions.signIn,
      tryAutoSignIn: types.user.actions.tryAutoSignIn,
      fill: types.main.actions.fill,
      registerUser: types.user.actions.register
    }),
    register () {
      if (!this.$refs.register.validate()) return
      this.loggingIn = true
      this.registerUser({
        email: this.registeremail,
        password: this.registerpassword,
        firstname: this.registerfirstname,
        lastname: this.registerlastname
      })
    },
    async submit () {
      if (!this.$refs.login.validate()) return
      this.loggingIn = true

      try {
        await this.signIn({
          username: this.email,
          password: this.password
        })
      } catch (err) {
        if (err && err.code === 'auth/account-exists-with-different-credential') {
          this.currentAccountType = 'facebook'
          this.showResetAccount = true
        }
      }
    },
    async facebookLogin () {
      this.loggingIn = true
      try {
        await this.signInWithFacebook()
      } catch (err) {
        if (err && err.code === 'auth/account-exists-with-different-credential') {
          this.currentAccountType = 'password'
          this.showResetAccount = true
        }
      }
    },
    appleLogin () {
      this.loggingIn = true
      this.signInWithApple()
    },
    newUser () {
      this.showRegisterPage = true
    },
    backToLogin () {
      this.showRegisterPage = false
    },
    emailEnter () {
      this.$refs.password.focus()
    },
    passwordEnter () {
      if (!this.$refs.login.validate()) {
        this.$refs.email.focus()
        return
      }
      this.submit()
    }
  },
  watch: {
    info (val) {
      this.loggingIn = false
    }
  }
}
